import { render, staticRenderFns } from "./payfor-refund.vue?vue&type=template&id=5e60933d&scoped=true"
import script from "./payfor-refund.vue?vue&type=script&lang=js"
export * from "./payfor-refund.vue?vue&type=script&lang=js"
import style0 from "./payfor-refund.vue?vue&type=style&index=0&id=5e60933d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e60933d",
  null
  
)

export default component.exports